module.exports = __webpack_public_path__ + "img/mareteam_6.0b21d8ee.png";